import  styled  from '@emotion/styled';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import BotaoRosa from '../../components/Botao/BotaoRosa';
import BotaoVerde from '../../components/Botao/BotaoVerde';
const Container = styled.span`
    background: #201F1F;
    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;
    
    width: 100vw;
    height: 100vh;

    overflow: hidden;
    font-family: 'Inter';
    font-style: normal;

    gap: 20px;
`
const ContainerButtons = styled.span`
    display: flex;
    gap: 20px;
`

const Titulo = styled.span`
    font-weight: 400;
    font-size: 18vw;
    
    line-height: 14vw;
    color: #0765E3;
`

const SubTitulo = styled.span`
    
    font-weight: 400;
    font-size: 3vw;

    color: #FFFFFF;
`

const Detalhes = styled.span`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 1.6vw;
    text-align: center;
    width: 66vw;
    color: #FFFFFF;
`

function Page404() {
    const navigate = useNavigate();
  return (
    <Container>
        <Titulo>404</Titulo>
        <SubTitulo>Oops! Something wrong</SubTitulo>
        <Detalhes>Curabitur blandit tempus porttitor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Maecenas faucibus mollis interdum.</Detalhes>
        <ContainerButtons >
            <BotaoVerde text="Voltar" pd="20px" onClick={()=> navigate("/home")}/>
            <BotaoRosa text="Home" pd="20px"/>
        </ContainerButtons>
    </Container>
  )
}

export default Page404;